export default "__VITE_ASSET__604d4844__"